<nz-spin [nzSpinning]="isLoading">
    <div class="base-info">
        <label class="label-font item">{{ "LoginAccount" | translate }}:<span
                style="margin-left: 10px;">{{accountInfo.loginAccount}}</span></label>
        <label class="label-font item">{{ "AccountUser" | translate }}:<span
                style="margin-left: 10px;">{{accountInfo.accountUser}}</span></label>
        <label class="label-font item">{{ "AccountEmail" | translate }}:<span
                style="margin-left: 10px;">{{accountInfo.accountEmail}}</span></label>
    </div>
    <div *ngIf="showVendorInfo" class="vendor-info">
        <nz-table #colSpanTable [nzData]="displayVendorInfo" nzSize="middle" nzShowSizeChanger
            [nzFrontPagination]="false" [nzShowPagination]="false" [nzScroll]="{ y: '55vh' }">
            <thead>
                <tr>
                    <th scope="col" style="text-align: center" [nzSortFn]="true" [nzShowSort]="false" nzWidth="110px">
                        {{ "VendorCode" | translate }}
                    </th>
                    <th scope="col" style="text-align: center" [nzSortFn]="true" [nzShowSort]="false" nzWidth="140px">
                        {{ "VendorName" | translate }}
                    </th>
                    <th scope="col" style="text-align: center" [nzSortFn]="true" [nzShowSort]="false" nzWidth="120px">
                        {{ "table.VendorAddress" | translate }}
                    </th>
                    <th scope="col" style="text-align: center" [nzSortFn]="true" [nzShowSort]="false" nzWidth="110px">
                        {{ "linkman" | translate }}
                    </th>
                    <th scope="col" style="text-align: center" [nzSortFn]="true" [nzShowSort]="false" nzWidth="120px">
                        {{ "table.ContactMobile" | translate }}
                    </th>
                    <th scope="col" style="text-align: center" [nzSortFn]="true" [nzShowSort]="false" nzWidth="120px">
                        {{ "table.ContactEmail" | translate }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let data of colSpanTable.data; let i = index">
                    <td style="text-align:center;">{{data.vendorCode}}</td>
                    <td style="text-align:center;">{{data.vendorName }}</td>
                    <td style="text-align:center;">{{data.vendorAddress}}</td>
                    <td style="text-align:center;">{{data.contactPerson}}</td>
                    <td style="text-align:center;">{{data.contactMobile}}</td>
                    <td style="text-align:center;">{{data.contactEmail}}</td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</nz-spin>